import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { GlobalErrorHandler, Holding } from '..'

export class HoldingApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  getHoldings = async () => {
    return this.fetchInstance.get(ApiEndpoints.HOLDINGS).then((data) => data.holdings)
  }

  updateHoldings = async (holding: Holding) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.HOLDINGS}/${holding.guid}`, holding)
      .then((data) => data.holding)
  }
}
